import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 40px;
  `,
  illustration: css`
    padding: 40px 34px;
  `,
  description: css`
    padding: 16px 16px 0px 16px;
  `,
  textCenter: css`
    text-align: center;
  `,
  bottom: css`
    padding-top: 24px;
  `,
};

export default styles;
